import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewShippingRate from "../../../../components/@shipping/shipping_rates/NewShippingRate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRateNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewShippingRate
                routeType={routeType}
            />
        </SettingFrame>
    )
}       